import { logoutOpsUser } from "../services/authApi";
import { clearOpsPermissionsCache } from "../services/permissionsApi";
import { clearOpsRolesCache } from "../services/rolesApi";
import { logout } from "../store/slices/authSlice";

/**
 * Clear server session (Bearer token, no body) then Redux.
 * Pass the current auth token so the API can revoke it.
 */
export async function performLogout(dispatch, token) {
  await logoutOpsUser(token);
  clearOpsPermissionsCache();
  clearOpsRolesCache();
  dispatch(logout());
}
